import { useContext, useEffect } from "react";
import { UserStore } from "../..";
import BreadCrumbs from "../../components/breadcrumsb";
import { PageContainer } from "../../components/page";
import { runAuthHandler } from "../util";
import { useNavigate } from "react-router";
import LinkCreator from "./LinkCreator";

const PAGE_TITLE = "Create Link Page";

const CreateAboutLinkPage = () => {
  const navigate = useNavigate();
  const userStore = useContext(UserStore);
  const { selectedVenue } = userStore;

  useEffect(() => {
    runAuthHandler({ userStore, navigate });
  }, [selectedVenue]);

  return (
    <PageContainer>
      <BreadCrumbs
        routes={[
          { path: "/home", breadcrumbName: "Home" },
          { path: "/mobile-about-us", breadcrumbName: "Mobile About Us" },
          {
            path: "/mobile-about-us/create",
            breadcrumbName: "Create Link Page",
          },
        ]}
      />
      <div className="text-3xl mb-6 text-center font-bold">{PAGE_TITLE}</div>
      <div className="w-full">
        <LinkCreator />
      </div>
    </PageContainer>
  );
};

export default CreateAboutLinkPage;
